var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationiconsmain({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96189 15.986H16.7719C17.0371 16.0009 17.3017 15.9475 17.5404 15.8311C17.7791 15.7147 17.9841 15.5391 18.1357 15.321C18.2873 15.1029 18.3805 14.8497 18.4065 14.5853C18.4324 14.321 18.3902 14.0544 18.2839 13.811C17.9239 12.723 16.4889 11.418 16.4889 10.134C16.4889 7.284 16.4889 6.534 15.0849 4.858C14.6305 4.31853 14.0672 3.88129 13.4319 3.575L12.6489 3.195C12.5175 3.11569 12.4042 3.00978 12.3162 2.88406C12.2282 2.75834 12.1674 2.61559 12.1379 2.465C12.0596 1.9574 11.7912 1.49858 11.3871 1.18159C10.983 0.86459 10.4735 0.713156 9.96189 0.757997C9.4595 0.727829 8.9639 0.886013 8.57189 1.20166C8.17988 1.5173 7.9196 1.96774 7.84189 2.465C7.80664 2.62079 7.73758 2.76693 7.6396 2.89308C7.54162 3.01922 7.41711 3.12229 7.27489 3.195L6.49189 3.575C5.85692 3.88141 5.29394 4.31864 4.83989 4.858C3.43689 6.534 3.43689 7.284 3.43689 10.134C3.43689 11.418 2.06689 12.592 1.70689 13.745C1.48989 14.442 1.36989 15.986 3.18689 15.986H9.96189Z",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.225 15.986C13.2335 16.4169 13.155 16.845 12.994 17.2448C12.8331 17.6445 12.5931 18.0077 12.2883 18.3124C11.9836 18.6171 11.6205 18.8571 11.2207 19.0181C10.821 19.179 10.3928 19.2576 9.96196 19.249C9.531 19.2581 9.10264 19.18 8.70268 19.0192C8.30272 18.8585 7.93942 18.6184 7.63467 18.3136C7.32991 18.0087 7.08999 17.6454 6.92935 17.2453C6.76872 16.8453 6.69069 16.417 6.69996 15.986",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationiconsmain);
export default __webpack_public_path__ + "static/media/notificationiconsmain.de87556b9eaa23f8c2ea8e73d5c6b8f7.svg";
export { ForwardRef as ReactComponent };